import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import FemaleIcon from '@mui/icons-material/Female';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import MaleIcon from '@mui/icons-material/Male';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import ParkIcon from '@mui/icons-material/Park';
import PetsIcon  from '@mui/icons-material/Pets';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import FlagIcon from '@mui/icons-material/Flag';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import SquareFootIcon from '@mui/icons-material/SquareFoot';

export const seasonalCategoryIcons = {
    "black-friday": LocalFireDepartmentIcon,
    "carnaval": TheaterComedyIcon,
    "copa-do-mundo-2022": SportsSoccerIcon,
    "dia-das-maes": FemaleIcon,
    "dia-dos-namorados": FavoriteBorderIcon,
    "dia-dos-pais": MaleIcon,
    "esquenta-black-friday": LocalOfferIcon,
    "natal": ParkIcon,
    "pascoa": PetsIcon ,
    "Quinzena-do-cliente": LocalActivityIcon,
    "quinzena-do-consumidor": ShoppingCartIcon,
    "semana-do-brasil": FlagIcon,
    "verao": BeachAccessIcon,
    "volta-as-aulas": SquareFootIcon
};
